module.exports = __webpack_public_path__ + "static/media/Terms_and_Condition_ of_ Submission.e297e5f1.pdf";